export const CONSTANTS = {
  GET_MAIN_LIST: "GET_MAIN_LIST",

  ADD_CARD_LOCALLY: "ADD_CARD_LOCALLY",

  REMOVE_CARD_LOCALLY: "REMOVE_CARD_LOCALLY",

  ADD_LIST_LOCALLY: "ADD_LIST_LOCALLY",

  UPDATE_CARD_LOCALLY: "UPDATE_CARD_LOCALLY",
  UPDATE_LIST_HEADING: "UPDATE_LIST_HEADING",

  REMOVE_LIST_LOCALLY: "REMOVE_LIST_LOCALLY",

  HANDLE_DRAG_DROP: "HANDLE_DRAG_DROP",

  SET_BOARD_ID: "SET_BOARD_ID",

  ADD_BOARD: "ADD_BOARD",
  REMOVE_BOARD: "REMOVE_BOARD",

  UPDATE_BOARD_TITLE: "UPDATE_BOARD_TITLE",
  SAVE_IN_FIREBASE: "SAVE_IN_FIREBASE",
};
